import React, { useState } from 'react';
import './index.scss';

const MultiSelectComponent = ({ item, index, onSelectProduct, pIndex }) => {
  const { id, name, quantity } = item;

  const [isActive, setIsActive] = useState(quantity > 0);
  const handleButtonClick = () => {
    setIsActive(prevIsActive => {
      const newIsActive = !prevIsActive;
      const updatedQuantity = newIsActive ? 1 : 0;
      onSelectProduct(id, updatedQuantity, index, pIndex);
      return newIsActive;
    });
  };

  return (
    <div className="multi-select-container">
      <button
        className={`multi-select-button ${isActive ? 'active' : ''}`}
        onClick={handleButtonClick}
      >
        {name}
      </button>
    </div>
  );
};

export default MultiSelectComponent;
